import { getDefaultStore } from 'jotai';
import { currentUserAtom, authLoadedAtom } from './AuthAtoms';
import { loginUser, logoutUser, registerUser, fetchUserDetails, forgotPassword, confirmForgotPassword } from '../api/auth';
import { triggerFatigueHeal } from '../api/fatigue';

const store = getDefaultStore();

export const handleLogin = async (username, password) => {
    try {
        const authResult = await loginUser(username, password);
        const { AccessToken, IdToken, RefreshToken } = authResult;

        // Save tokens and username to localStorage
        localStorage.setItem('accessToken', AccessToken);
        localStorage.setItem('idToken', IdToken);
        localStorage.setItem('refreshToken', RefreshToken);
        localStorage.setItem('username', username);

        // Fetch user details using the access token (matches AuthInitializer + axios interceptor)
        const userDetails = await fetchUserDetails(AccessToken);

        // Update state using Jotai atoms
        store.set(currentUserAtom, userDetails.user);
        store.set(authLoadedAtom, true);
        triggerFatigueHeal(); // fire-and-forget: heal runs in background
    } catch (error) {
        console.error('Login failed:', error.message);
        throw error; // Ensure to propagate the error
    }
};

export const handleLogout = async () => {
    try {
        await logoutUser();

        // Remove tokens from localStorage
        localStorage.removeItem('accessToken');
        localStorage.removeItem('idToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('username');
        localStorage.removeItem('authOrigin');

        // Clear user from state
        store.set(currentUserAtom, null);
        store.set(authLoadedAtom, false); // Reset authLoaded to false after logout
    } catch (error) {
        console.error('Logout failed:', error.message);
        throw error; // Ensure to propagate the error
    }
};

export const handleRegister = async (username, email, password) => {
    try {
        const data = await registerUser(username, email, password);
        return data;
    } catch (error) {
        console.error('Registration failed:', error.message);
        throw error; // Ensure to propagate the error
    }
};

export const handleForgotPassword = async (username) => {
    try {
        return await forgotPassword(username);
    } catch (error) {
        console.error('Forgot password failed:', error.message);
        throw error;
    }
};

export const handleConfirmForgotPassword = async (username, code, newPassword) => {
    try {
        return await confirmForgotPassword(username, code, newPassword);
    } catch (error) {
        console.error('Confirm forgot password failed:', error.message);
        throw error;
    }
};
